import { useState } from 'react'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

import { useUpdateApplianceHdoDependency } from '@/hooks/use-appliance'
import { Hint } from '@/views/wizard/steps/wizard-common'

function ApplianceHdoDependencyToggle({
    applianceId,
    isDependentOnHdo,
}: {
    applianceId: string | number,
    isDependentOnHdo: boolean,
}) {

    const [checked, setChecked] = useState<boolean>(!isDependentOnHdo)

    const mutation = useUpdateApplianceHdoDependency(applianceId)

    const handleChecked = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked)
        mutation.mutate({isDependentOnHdo: !event.target.checked})
    }
    
    return (
        <Box display="flex" flexDirection="column" mt={1} mb={2}>
            <FormControlLabel control={
                <Checkbox
                    checked={checked}
                    onChange={handleChecked}
                />
            } label="Ignorovat HDO blokování" />
            <Hint>
                Pokud HDO v době vysokého tarifu ("denní proud") zásuvku zcela odpojí, nebudeme schopni bojler zapnout. Prosíme respektujte smlouvu se svým distributorem o časech spínání.
            </Hint>
            
        </Box>
    )
}

export default ApplianceHdoDependencyToggle
